<template>
  <span class="inline-flex items-center">
    <img
        src="../assets/contact.png"
        alt="contact"
        />
    <span class="font-bold text-[26px] ml-[12px] text-tWhite">{{ $t('Contact us') }}</span>
  </span>
</template>
